<div class="container">
  <div class="head">
    <div mat-dialog-title
         class="head-label">{{'MENU.DISHES.NEW.RELATED_PRODUCTS_PROGRAM' | translate}}
    </div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>
  <form [formGroup]="form">

    <mat-form-field class="dish-name" appearance="fill">
      <mat-icon *ngIf="isNameDifferent()" (click)="restoreName()">restore</mat-icon>
      <mat-label>{{'MENU.DISHES.NEW.RELATED_PRODUCTS_NAME' | translate}}</mat-label>
      <input matInput type="text" formControlName="rpProgramName" [class.isDifferent]="isNameDifferent()">
    </mat-form-field>

    <div *ngIf="data.organization.additionalLanguages">
      <mat-form-field class="dish-name" appearance="fill"
                      *ngFor="let lang of data.organization.additionalLanguages">
        <mat-label>{{ 'MENU.DISHES.NEW.RELATED_PRODUCTS_NAME' | translate }} {{ lang }}</mat-label>
        <input matInput type="text" formControlName="{{lang}}">
      </mat-form-field>
    </div>

    <div>
      <div *ngIf="relatedProductIds">
        <p>{{ 'MENU.DISHES.NEW.RELATED_PRODUCTS' | translate }}</p>
        <div *ngFor="let relatedProductId of relatedProductIds ">
          <div>{{ data.products.get(relatedProductId)?.name ?? relatedProductId }}</div>
        </div>
      </div>
      <mat-icon (click)="editRelatedProducts()">edit</mat-icon>
      <label *ngIf="form.hasError('relatedProductIds')" class="error">{{form.errors['relatedProductIds']}}</label>
    </div>

    <div>
      <span>
        <span>{{ 'MENU.IS_MANUALLY_CREATED' | translate }}</span>
        <input type="checkbox" formControlName="isManuallyCreated" />
      </span>
    </div>

    <div class="form-bottom" style="display: flex">
      <button
        class="button"
        mat-button
        type="submit"
        style="flex: auto"
        (click)="submit()"
      >{{ 'MENU.SAVE' | translate }}
      </button>

      <button
        *ngIf="isManuallyCreated()"
        mat-button
        type="button"
        (click)="remove()"
        style="flex: auto"
      >{{ 'MENU.DELETE' | translate }}
      </button>
    </div>
  </form>
</div>
